module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"biblio":"library","save":"Save","version":"About","langue":"Language","created":"Created by Ankh using "},"fr":{"biblio":"Bibliothèque","save":"Sauvegarde","version":"A propos","langue":"Langues","created":"Créé par Ankh avec "}}')
  delete Component.options._Ctor
}
